var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCallIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_6086",
    x: 0,
    y: 0,
    width: 105,
    height: 105,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Call",
    transform: "translate(-215.5 -627.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 215.5, 627.5)",
    filter: "url(#Path_6086)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6086-2",
    "data-name": "Path 6086",
    d: "M30,0A30,30,0,1,1,0,30,30,30,0,0,1,30,0Z",
    transform: "translate(17.5 17.5)",
    fill: "#ff8300"
  })), /*#__PURE__*/React.createElement("path", {
    id: "call-_192_",
    "data-name": "call-[#192]",
    d: "M76.459,7186.99c-.926,2.814-4.554,4.218-7.146,3.984-3.54-.32-7.392-2.2-10.315-4.266a33.973,33.973,0,0,1-10.669-12.73c-1.658-3.527-2.03-7.862.436-11.077a4.241,4.241,0,0,1,3.38-1.9c2.056-.1,2.344,1.077,3.05,2.909.526,1.37,1.228,2.768,1.62,4.188.734,2.651-1.832,2.76-2.156,4.926-.2,1.366,1.454,3.2,2.2,4.172a20.22,20.22,0,0,0,5.216,4.8c1.14.718,2.976,2.012,4.28,1.3,2.008-1.1,1.82-4.486,4.626-3.34a45.234,45.234,0,0,1,4.25,2.194c2.146,1.155,2.046,2.35,1.228,4.834-.612,1.857.612-1.855,0,0",
    transform: "translate(201 -6501)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/callIcon.626cfd2a8ccef8f5bf7c0f1df4d75d71.svg";
export { ForwardRef as ReactComponent };